import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-group form-group-block", _ctx.borderClass])
    }, [
      _createElementVNode("label", null, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _renderSlot(_ctx.$slots, "description")
  ], 64))
}